import { useId, useState } from "react";
import { formatHoursMinutes, parseMinutes } from "@/lib/duration";
import { DurationField } from "./task-detail/DurationField";

const toText = (minutes: number) => (minutes ? formatHoursMinutes(minutes) : "");

export function EstimatedTimeField({
	value,
	onChange,
}: {
	value: number;
	onChange: (minutes: number) => void;
}) {
	const id = useId();
	const [text, setText] = useState(() => toText(value));
	const [synced, setSynced] = useState(value);

	// Parent reset/prefill (e.g. dialog reopened): resync text during render.
	if (value !== synced) {
		setSynced(value);
		if ((parseMinutes(text) ?? 0) !== value) setText(toText(value));
	}

	function handleText(next: string) {
		setText(next);
		const minutes = next.trim() ? parseMinutes(next) : 0;
		// Invalid input keeps the last valid value; DurationField shows the error.
		if (minutes != null) {
			setSynced(minutes);
			onChange(minutes);
		}
	}

	return (
		<div className="flex flex-col gap-1.5">
			<label htmlFor={id} className="text-sm font-medium text-muted-foreground">
				Estimated time <span className="font-normal">(optional)</span>
			</label>
			<DurationField
				id={id}
				text={text}
				onTextChange={handleText}
				emptyHint="No estimate. Enter minutes or 1h 30m."
			/>
		</div>
	);
}
